// i18n
import BusinessProfileForm from 'presentations/views/containers/organisms/BusinessProfileForm';
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import styled from '@emotion/styled';
import { white } from 'presentations/views/styles/color';
import Headline from 'presentations/views/components/atoms/Headline';
import DashboardPageTemplate from 'presentations/views/components/templates/DashboardPageTemplate';
import { spacing, mediaMax, borderRadius } from 'presentations/views/styles';
import { ViewerItem } from 'presentations/api/schema/user';
import { useBusinessProfilePage } from './hooks';
import { useContext } from 'react';
import DashboardServiceNavigation, {
  SectionAdminView,
} from 'presentations/views/components/organisms/DashboardServiceNavigation';
import { DashboardPortalContext } from 'presentations/reducers/DashboardPortal';
import { Role } from 'domains/models/team_user/role';
import Dialog from 'presentations/views/components/atoms/Dialog';
import DialogSubmitField from 'presentations/views/components/molecules/DialogSubmitField';

interface Props {
  viewer?: ViewerItem;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const { state: dashboardState } = useContext(DashboardPortalContext);
  const viewer = props.viewer || dashboardState.viewer!;
  const { state, actions } = useBusinessProfilePage({
    viewer,
  });
  const isError = viewer.role > Role.Admin;

  return (
    <DashboardPageTemplate
      title={t('title')}
      viewer={viewer}
      isMobileTabHidden
      customHeader={
        <DashboardServiceNavigation
          viewer={viewer}
          activeIndex={SectionAdminView.businessProfile}
        />
      }
      tabBarContent={
        !state.isLoading && (
          <Container>
            {!isError && (
              <Main>
                <BusinessProfileContainer>
                  <StartContainer>
                    <BusinessProfileForm
                      id="basic"
                      businessProfile={state.businessProfile}
                      shopAccount={state.shopAccount}
                      viewer={viewer}
                      isOpen={state.isOpen}
                      onCancel={actions.onCancel}
                      onSave={actions.onSave}
                      onEdit={actions.onEdit}
                    />
                  </StartContainer>
                </BusinessProfileContainer>
              </Main>
            )}
            <Dialog
              isOpen={state.isOpenOnboard}
              onClose={actions.onCloseOnboard}
              maxHeight={'800px'}
              actions={
                <DialogSubmitField
                  onSubmit={actions.onCloseOnboard}
                  submitLabel={t('Comfirm')}
                />
              }
            >
              <Block>
                <OnboardHeadline variant="h1">
                  {t('onboard title')}
                </OnboardHeadline>
                <OnboardDescription>
                  {t('onboard_description.0')}
                  <b>{t('onboard_description.1')}</b>
                  {t('onboard_description.2')}
                </OnboardDescription>
              </Block>
            </Dialog>
          </Container>
        )
      }
    />
  );
}

const Container = styled.div`
  display: flex;
  ${mediaMax.tablet} {
    flex-direction: column;
  }
  padding-bottom: ${spacing(24)};
`;
const Main = styled.div`
  flex: 1;
  margin-right: ${spacing(24)};
  ${mediaMax.tablet} {
    margin-right: 0;
  }
`;

const BusinessProfileContainer = styled.div`
  margin-top: ${spacing(48)};
  padding-left: ${spacing(24)};
  ${mediaMax.tablet} {
    margin-top: ${spacing(24)};
    padding: 0 ${spacing(12)};
  }
`;

const StartContainer = styled.div`
  min-height: 100%;
  padding: ${spacing(32)};
  background-color: ${white};
  border-radius: ${borderRadius(16)};

  ${mediaMax.tablet} {
    padding: ${spacing(20)} ${spacing(12)};
    margin: ${spacing(16)} ${spacing(12)};
  }
`;

const OnboardHeadline = styled(Headline)`
  text-align: center;
  margin-bottom: ${spacing(16)};
`;
const OnboardDescription = styled.p`
  text-align: center;
  max-width: 420px;
  margin: 0 auto;
  white-space: pre-wrap;
`;
const Block = styled.div`
  margin-bottom: ${spacing(32)};
`;
